import { useState } from 'react';
import './FAQ.css';

interface FAQItem {
  question: string;
  answer: string;
}

const faqData: FAQItem[] = [
  {
    question: "What if my footage isn't good enough?",
    answer:
      "Here's the truth: you probably have more than you think. And \"good\" is subjective. That shaky phone video of your toddler laughing at the dog? That's gold. The slightly blurry first birthday? That's the whole point. We're not looking for Hollywood production values - we're looking for real moments. And we know how to make them shine.",
  },
  {
    question: 'My files are an absolute disaster',
    answer:
      "Welcome to the club. That's literally why we exist. You don't need to rename anything, organise anything, or even know where half of it is. Send us the chaos. Finding the story in the mess is what we do.",
  },
  {
    question: "I wouldn't even know where to start",
    answer:
      "Neither did we, and we work in television. That's what the consultation is for - we'll chat about what you've got, what moments matter most, and what you're hoping to feel when you watch it. No pressure, no judgment, just a conversation. We've guided plenty of people through this. You're in good hands.",
  },
  {
    question: "What if I don't like how it turns out?",
    answer:
      "Then we'll fix it. This is collaborative - you're involved in the creative decisions along the way, and we'll revise until you're genuinely thrilled. This is your family's story. We're not done until you love it.",
  },
  {
    question: 'Do you have Working With Children Checks and Police Clearance?',
    answer:
      "Yes. We hold Working With Children Checks (WWCC) and Police Clearance, and we're happy to confirm details during your consult. We also treat your footage as private and only keep it for as long as needed to edit and deliver your film.",
  },
  {
    question: "Can you edit footage you didn't shoot?",
    answer:
      "Absolutely. If it's on a phone, camera, hard drive, or shared folder, we can work with it. We've edited weddings shot by friends or family, memorial / celebration of life tributes, milestone montages, travel films, and more.",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="faq section fractured-light-bg">
      <div className="container">
        <h2 className="faq-heading">
          <span className="faq-heading-line">A Few Doubts You</span>
          <span className="faq-heading-line">Might Have...</span>
        </h2>
        <p className="faq-subtitle">These are the same thoughts we had when we started.</p>
        <div className="faq-list">
          {faqData.map((item, index) => (
            <div key={index} className={`faq-item ${openIndex === index ? 'open' : ''}`}>
              <button
                className="faq-question"
                onClick={() => toggleFAQ(index)}
                aria-expanded={openIndex === index}
              >
                <span className="faq-question-text">{item.question}</span>
                <span className="faq-chevron" aria-hidden="true">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4 6L8 10L12 6"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </button>
              {openIndex === index && (
                <div className="faq-answer">
                  <p>{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
